import { useSelector, useDispatch } from "react-redux";
import React, { useState, useEffect } from "react";
import Icon from "@mdi/react";
import { mdiMagnify, mdiPrinter } from "@mdi/js";
import { getBranch } from "utils/utils";
import moment from "moment";
import arrowShow from "Resources/ImagesNew/icon_filters_.png";
import { DateTimePicker } from "react-widgets";
import "moment/locale/vi";
import LangugeVi from "constants/vi";
import {
    getListDanhSachDonHang,
    updateDataSearch,
} from "../../../actions/DanhSachDonHang";
import {
    getUserLogin,
    utilsOnChangeSelectTypeDateMain,
    utilsOnChangeSelectTypeDateMainNew,
} from "../../../utils/utils";
import { convertToNumber } from "utils/currencyFormat";
import { Cookies } from "react-cookie";
moment.locale("vi", LangugeVi.VietNamese);

export const SearchBar = ({
    isShowTinhThanh,
    isShowNVKD,
    isConfigChot,
    isConfigMaPO,
}) => {
    const dispatch = useDispatch();

    const dataSearch = useSelector((state) => state.dataSearchDanhSachDonHang);
    const listDonHang = useSelector((state) => state.listDanhSachDonHang);

    var fromDate = new Date();
    var toDate = new Date();
    let params = new URLSearchParams(window.location.search);
    let customerID = params.get("customerID");
    if (customerID > 0) {
        fromDate = new Date(moment().startOf("year").format("YYYY-MM-DD"));
        toDate = new Date(moment().endOf("year").format("YYYY-MM-DD"));
        // fromDate = new Date('2020-01-01');
    }
    const [dateToNew, setDateToNew] = useState(toDate);
    const [dateFromNew, setDateFromNew] = useState(fromDate);
    const [listNVKD, setListNVKD] = useState([]);

    useEffect(() => {
        let UserName = getUserLogin();
        if (
            listNVKD.length === 1 &&
            !dataSearch.sNVKDUserName &&
            dataSearch.iLoaiDon === 2 &&
            UserName.UserName == listNVKD[0].UserName
        ) {
            const selectedUser = listNVKD[0].UserName;

            // Gọi sau một chút để đảm bảo API trước đã chạy xong (nếu cần)
            setTimeout(() => {
                updateState("sNVKDUserName", selectedUser);

                const newDataSearch = {
                    ...dataSearch,
                    sNVKDUserName: selectedUser,
                };

                dispatch(getListDanhSachDonHang(newDataSearch));
            }, 0); // có thể set 300-500ms nếu muốn chờ chắc chắn
        }
    }, [listNVKD, dataSearch.iLoaiDon]);

    useEffect(() => {
        // Do yêu cầu vào từ bất kì đâu cũng cần giữ lại pagesize chứ k chỉ là refresh trang
        dataSearch.iPageSize = sessionStorage.getItem("BanGhiDanhSachDonHang") ?? 20;

    }, []);



    const updateState = (field, text) => {
        dispatch(
            updateDataSearch({
                ...dataSearch,
                [field]: text,
            })
        );
    };

    const updateTextValue = (field) => (e) => {
        updateState(field, e.target.value);
    };

    const onChangeTypeDate = (field) => (e) => {
        const thongtin = { ...dataSearch };
        thongtin[field] = e.target.value;
        utilsOnChangeSelectTypeDateMainNew(thongtin);
        dispatch(
            updateDataSearch({
                ...thongtin,
                [field]: e.target.value,
                pageIndex: 1,
            })
        );
    };

    const [isOpen, setIsOpen] = useState(false);
    const [isOpen1, setIsOpen1] = useState(false);

    const onChangeDate = (field) => (e) => {
        setDateFromNew(e);
        updateState(field, moment(e).format("YYYY-MM-DD"));
    };

    const onChangeDate1 = (field) => (e) => {
        setDateToNew(e);
        updateState(field, moment(e).format("YYYY-MM-DD"));
    };
    //

    const loadTaiSan = () => {
        getListDanhSachDonHang(dataSearch);
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }; // set lên đầu page ví dụ khi phân trang

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            onSearch();
        }
    };
    const onSearch = () => {
        if (getBranch() == 0 || getBranch() == "0") {
            console.log(getBranch(), "getBranch()getBranch()getBranch()");
            const cate = { ...listDonHang };
            var strBranch = "";
            // Set lai gia tri khi click
            cate.List2.map((row, i) => {
                if (row.IsCheck === 1) {
                    strBranch = strBranch + "_" + row.BranchID;
                }
            });
            const searchNew = {
                fromDate: dataSearch.fromDate,
                toDate: dataSearch.toDate,
                typeDate: dataSearch.typeDate,
                sSearch: dataSearch.sSearch,
                sUserName: dataSearch.sUserName,
                sCustomerName: dataSearch.sCustomerName,
                iTrangThaiTruKho: dataSearch.iTrangThaiTruKho,
                iTrangThaiThanhToan: dataSearch.iTrangThaiThanhToan,
                iBranch: dataSearch.iBranch,
                sBranch: strBranch,
                sNVKDUserName: dataSearch.sNVKDUserName,
                lstNhomKH: dataSearch.lstNhomKH,
                iLoaiDon: dataSearch.iLoaiDon,
                iLoaiDoiTac: dataSearch.iLoaiDoiTac,
                iPageIndex: 1,
                iPageSize: dataSearch.iPageSize,
                TinhThanhPhoId: dataSearch.TinhThanhPhoId,
                QuanhuyenId: dataSearch.QuanhuyenId,
                PhuongxaId: dataSearch.PhuongxaId,
            };
            dispatch(getListDanhSachDonHang(searchNew));
        } else {
            dataSearch.iPageIndex = 1;
            dispatch(getListDanhSachDonHang(dataSearch));
            loadTaiSan(dataSearch);
        }
    };
    //back trở lại giữ nguyên search
    //set giữ lại tìm kiếm
    useEffect(() => {
        const cookies = new Cookies();
        const objFiler = cookies.get("FilterDanhSachDonHangDaiLY");
        if (
            objFiler != null &&
            typeof objFiler != "undefined" &&
            typeof objFiler != ""
        ) {
            readFilter();
        }
    }, []);
    const readFilter = () => {
        const cookies = new Cookies();
        const objFiler = cookies.get("FilterDanhSachDonHangDaiLY");
        if (objFiler != null && typeof objFiler != "undefined") {
            // const thongtin = { ...objSearch };
            var arrFilter = objFiler.split("&");
            arrFilter.map((x, i) => {
                var arr = x.split("::");
                if (arr[0] === "fromDate") {
                    dataSearch.fromDate = arr[1];
                    setDateFromNew(new Date(arr[1]));
                } else if (arr[0] === "toDate") {
                    dataSearch.toDate = arr[1];
                    setDateToNew(new Date(arr[1]));
                } else if (arr[0] === "typeDate") {
                    dataSearch.typeDate = arr[1];
                } else if (arr[0] === "sSearch") {
                    dataSearch.sSearch = arr[1].trim();
                } else if (arr[0] === "sUserName") {
                    dataSearch.sUserName = arr[1];
                } else if (arr[0] === "sCustomerName") {
                    dataSearch.sCustomerName = arr[1].trim();
                } else if (arr[0] === "iTrangThaiTruKho") {
                    dataSearch.iTrangThaiTruKho = arr[1];
                } else if (arr[0] === "iTrangThaiThanhToan") {
                    dataSearch.iTrangThaiThanhToan = arr[1];
                } else if (arr[0] === "iBranch") {
                    dataSearch.iBranch = arr[1];
                } else if (arr[0] === "sBranch") {
                    dataSearch.sBranch = arr[1];
                } else if (arr[0] === "sNVKDUserName") {
                    dataSearch.sNVKDUserName = arr[1];
                } else if (arr[0] === "lstNhomKH") {
                    dataSearch.lstNhomKH = arr[1];
                } else if (arr[0] === "iLoaiDon") {
                    dataSearch.iLoaiDon = convertToNumber(arr[1]);
                } else if (arr[0] === "iLoaiDoiTac") {
                    dataSearch.iLoaiDoiTac = arr[1];
                } else if (arr[0] === "iPageIndex") {
                    dataSearch.iPageIndex = parseInt(arr[1]);
                } else if (arr[0] === "TinhThanhPhoId") {
                    dataSearch.TinhThanhPhoId = arr[1];
                }
            });
            dispatch(updateDataSearch(dataSearch));
        }
    };
    return (
        <>
            <div className="  search-main serach-textNew">
                <div className="row">
                    <div className="col-md-12 ">
                        <div className="row">

                            <div className="col-lg-2">
                                <div className="form-group">
                                    <label className="text-label-new">Mã đơn hàng</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={dataSearch.sSearch}
                                        onChange={updateTextValue("sSearch")}
                                        onKeyDown={(e) => handleKeyDown(e)}
                                    ></input>
                                </div>
                            </div>
                            <div className="col-lg-2">
                                <div className="form-group">
                                    <label className="text-label-new">Trạng thái thanh toán</label>
                                    <select
                                        class="form-control selectCss"
                                        value={dataSearch.iTrangThaiThanhToan}
                                        onChange={updateTextValue("iTrangThaiThanhToan")}
                                    >
                                        <option value="-1">Tất cả</option>
                                        <option value="0">Chưa thanh toán</option>
                                        <option value="2">Còn nợ</option>
                                        <option value="3">Đã thanh toán</option>
                                    </select>
                                </div>
                            </div>
                            <div className="col-lg-2">
                                <div className="form-group">
                                    <label className="text-label-new">Thời gian</label>
                                    <select
                                        class="form-control selectCss"
                                        value={dataSearch.typeDate}
                                        onChange={onChangeTypeDate("typeDate")}
                                    >
                                        <option value="1">Hôm nay</option>
                                        <option value="2">Hôm qua</option>
                                        <option value="3">Tuần này</option>
                                        <option value="4">Tuần trước</option>
                                        <option value="5">Tháng này</option>
                                        <option value="6">Tháng trước</option>
                                        <option value="7">Quý này</option>
                                        <option value="8">Quý trước</option>
                                        <option value="9">Năm này</option>
                                        <option value="10">Năm trước</option>
                                        <option value="11">Tùy chọn khác</option>
                                    </select>
                                </div>
                            </div>
                            {dataSearch.typeDate === "11" && (
                                <>
                                    <div className="col-lg-2">
                                        <div className="form-group">
                                            <label className="text-label-new">Từ ngày</label>
                                            <DateTimePicker
                                                format={"DD/MM/YYYY"}
                                                time={false}
                                                onChange={onChangeDate("fromDate")}
                                                value={dateFromNew}
                                                culture="vi"
                                                open={isOpen}
                                                onFocus={() => setIsOpen("date")}
                                                onBlur={() => setIsOpen(false)}
                                                onSelect={() => setIsOpen(false)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-2">
                                        <div className="form-group">
                                            <label className="text-label-new">Đến ngày</label>
                                            <DateTimePicker
                                                format={"DD/MM/YYYY"}
                                                time={false}
                                                onChange={onChangeDate1("toDate")}
                                                value={dateToNew}
                                                culture="vi"
                                                open={isOpen1}
                                                onFocus={() => setIsOpen1("date")}
                                                onBlur={() => setIsOpen1(false)}
                                                onSelect={() => setIsOpen1(false)}
                                            />
                                        </div>
                                    </div>
                                </>
                            )}

                            {/* <div className="col-lg-2">
                                <div className="form-group">
                                    <label className="text-label-new">Bản ghi</label>
                                    <select
                                        class="form-control selectCss"
                                        value={dataSearch.iPageSize}
                                        onChange={updateTextValue("iPageSize")}
                                    >
                                        <option value="20">20</option>
                                        <option value="50">50</option>
                                        <option value="100">100</option>
                                        <option value="150">150</option>
                                        <option value="200">200</option>
                                        <option value="250">250</option>
                                    </select>
                                </div>
                            </div> */}
                            <div className="col-lg-2" style={{ paddingTop: "20px" }}>
                                <button
                                    id="btnTimKiemDanhSachDonHang"
                                    className="button-Add-NoIcon bg-blue-main"
                                    onClick={onSearch}
                                >
                                    <Icon path={mdiMagnify} title="Tìm kiếm" size={1.3} />
                                    Tìm kiếm
                                </button>
                            </div>
                        </div>

                        <div className="col-md-4">
                            {/* <div className="align-end marT-20"></div> */}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
